import React from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "src/routes/PrivateRoute";
import { AdminPlansPage } from "../pages/admin";

export const routes = (
  <Route
    path="/admin/plans"
    element={
      <PrivateRoute>
        <AdminPlansPage />
      </PrivateRoute>
    }
  />
);
